// extracted by mini-css-extract-plugin
export default {"sort":"SQ-z","sortSelect":"TQ-z","disabled":"UQ-z"};